import { useEffect } from "react";

export const SITE_NAME = "The Sand Lab";
export const SITE_URL = "https://court-ammos.emergent.host";
export const DEFAULT_TITLE = "The Sand Lab — Beach Volleyball Academy Chania";
export const DEFAULT_DESCRIPTION = "The Sand Lab is a beach volleyball academy in Chania, Greece. Book your court, join training sessions and tournaments.";
export const KEYWORDS = "beach volley Chania, beach volley Greece, beach volleyball Chania, beach volley ακαδημία Χανιά, The Sand Lab";

const setMeta = (attr, key, content) => {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) { el = document.createElement("meta"); el.setAttribute(attr, key); document.head.appendChild(el); }
  el.setAttribute("content", content);
};

export function applySeo({ title, description, path, image, type = "website", noindex = false } = {}) {
  const fullTitle = title ? `${title} | ${DEFAULT_TITLE}` : DEFAULT_TITLE;
  const desc = description || DEFAULT_DESCRIPTION;
  const url = `${SITE_URL}${path || window.location.pathname}`;
  document.title = fullTitle;
  setMeta("name", "description", desc);
  setMeta("name", "keywords", KEYWORDS);
  setMeta("name", "robots", noindex ? "noindex, nofollow" : "index, follow");
  setMeta("property", "og:title", fullTitle);
  setMeta("property", "og:description", desc);
  setMeta("property", "og:url", url);
  setMeta("property", "og:type", type);
  setMeta("property", "og:site_name", SITE_NAME);
  setMeta("property", "og:image", image || `${SITE_URL}/landing-sandlab.jpg`);
  setMeta("name", "twitter:title", fullTitle);
  setMeta("name", "twitter:description", desc);
  setMeta("name", "twitter:image", image || `${SITE_URL}/landing-sandlab.jpg`);
  let canonical = document.head.querySelector('link[rel="canonical"]');
  if (!canonical) { canonical = document.createElement("link"); canonical.setAttribute("rel", "canonical"); document.head.appendChild(canonical); }
  canonical.setAttribute("href", url);
}

export function useSeo(opts, deps = []) {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { applySeo(opts); }, deps);
}
